import { DEVICE_PIXEL_RATIO } from 'ol/has';
import MapUtils from '../MapUtils';
// eslint-disable-next-line import/no-cycle
import LayerStyle from '../LayerStyle';

export default class SymbolStyle {
    public baseStyle!: SymbolStyle|undefined;

    svgIconUrl!: string|undefined;

    symbolStrokeColor!: string|undefined;

    symbolFillColor!: string|undefined;

    symbolStrokeWidth!: number|undefined;

    imgcache: any;

    svgData!: string;

    size: any;

    rotation: any;

    offsetZ:any = '0';

    propertyList=['svgIconUrl','symbolStrokeColor','symbolFillColor','symbolStrokeWidth','size'
      ,'offsetZ'
    ];

    constructor(json: any = null) {
      if (json) {
        Object.assign(this, json);
      }
      if (LayerStyle.defaultStyle !== undefined) {
        this.setBaseStyle(LayerStyle.defaultStyle.pointSymbol);
      }
    }

    public setBaseStyle(baseStyle: SymbolStyle) : void {
      this.baseStyle = baseStyle;
    }

    getSvgContent():any {
      if (this.svgData) {
        return MapUtils.replaceSvgColor(this.svgData,
          this.getSymbolFillColor(),
          this.getSymbolStrokeColor(),
          this.getSymbolStrokeWidth());
      }
      return undefined;
    }

    refreshSvgImage(): void {
      const svgContent = this.getSvgContent();
      if (!svgContent) {
        return;
      }
      const dataUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgContent)}`;
      if (this.imgcache) {
        this.imgcache.src = dataUrl;
        this.imgcache.loadedUrl = this.getSvgSymbolUrl();
      }
    }

    setDefaultValues() :void {
      this.symbolFillColor = 'rgba(51, 153, 204, 0.5)';
      this.symbolStrokeColor = '#000000';
      this.symbolStrokeWidth = 1;
      this.svgIconUrl = '';
      this.size = '16';
      this.offsetZ = '0';
    }
    setNoValues(value=undefined) :void {
      if(this.baseStyle){
        this.baseStyle=undefined;
      }
      let self:any=this;
      this.propertyList.forEach((element:string) => {
        self[element]=value
      });
    }
    setValues(newStyleInfos: any,noValue:any=undefined): void {
      let self:any=this;
      this.propertyList.forEach((element:string) => {
        if(newStyleInfos[element]!=noValue){
          self[element] = newStyleInfos[element];
        }
      });
      
    }


    toJson():any {
      return {
        svgIconUrl: this.svgIconUrl,
        size: this.size,
        offsetZ: this.offsetZ,
        symbolStrokeColor: this.symbolStrokeColor,
        symbolFillColor: this.symbolFillColor,
        symbolStrokeWidth: this.symbolStrokeWidth,
      };
    }

    getImage() {
      let img;
      if (this.imgcache && this.imgcache.loadedUrl === this.getSvgSymbolUrl()) {
        // useCache=false;
        img = this.imgcache;
      } else {
        const svgurl:any = this.getSvgIconUrl();
        if (svgurl.length > 0) {
          // useCache=false;
          return this.fetchIcon();
        }
      }
      return this.imgcache;
    }

    fetchIcon() : HTMLImageElement {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      const svgurl:any = this.getSvgIconUrl();
      const img = new Image();
      fetch(svgurl)
        .then(
          (response) => {
            if (response.status !== 200 && response.status !== 304) {
              return;
            }
            // Examine the text in the response
            response.text().then((data) => {
              let svgData = data;

              svgData = svgData.replace('<?xml version="1.0" encoding="UTF-8" standalone="no"?>', '')
                .replace('<?xml version="1.0" encoding="UTF-8"?>', '');

              self.svgData = svgData;
              svgData = self.getSvgContent();

              img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgData)}`;
              self.imgcache = img;
              self.imgcache.loadedUrl = self.getSvgSymbolUrl();
            });
          },
        )
        .catch((err) => {
          console.log('Fetch Error :-S', err);
        });
      return img;
    }

    getSvgIconUrl(): string|undefined {
      return this.svgIconUrl !== undefined ? this.svgIconUrl : this.baseStyle ? this.baseStyle.getSvgIconUrl(): undefined;
    }

    getSvgSymbolUrl(): string {
      let url = window.location.origin + window.location.pathname;
      const fillcolor = MapUtils.rgba2hex(this.getSymbolFillColor()).replace('#','%23');
      const strokecolor = MapUtils.rgba2hex(this.getSymbolStrokeColor()).replace('#','%23');
      if(!this.getSvgIconUrl()?.startsWith('http')){
        url += `${this.getSvgIconUrl()}`;
      }
      else{
        url = `${this.getSvgIconUrl()}`;
      }
      let separator='?';
      if (fillcolor.length > 0) {   
        if(url.indexOf('?')>0){
          separator='&amp;'
        }
        url += `${separator}fill=${fillcolor}&amp;fill-opacity=${MapUtils.rgba2opacity(this.getSymbolFillColor())}`;
      }
      if (strokecolor.length > 0) {
        separator='?';
        if(url.indexOf('?')>0){
          separator='&amp;'
        }
        url += `${separator}stroke=${strokecolor}&amp;stroke-width=${this.getSymbolStrokeWidth()}`;
      }
      return url;
    }

    getSymbolFillColor(): any{
      return (this.symbolFillColor !== undefined && this.symbolFillColor.length > 0)
        ? this.symbolFillColor : this.baseStyle ? this.baseStyle.getSymbolFillColor() : undefined;
    }

    getSymbolStrokeColor(): any {
      return (this.symbolStrokeColor !== undefined && this.symbolStrokeColor.length > 0)
        ? this.symbolStrokeColor : this.baseStyle ? this.baseStyle.getSymbolStrokeColor(): undefined;
    }

    getSymbolStrokeWidth(): any{
      return this.symbolStrokeWidth !== undefined
        ? this.symbolStrokeWidth : this.baseStyle ? this.baseStyle.getSymbolStrokeWidth(): undefined;
    }

    getSize(): any {
      return this.size !== undefined ? this.size : this.baseStyle ? this.baseStyle.getSize(): undefined;
    }

    getOffsetZ(): any {
      return this.offsetZ !== undefined ? this.offsetZ : this.baseStyle ?this.baseStyle.getOffsetZ(): undefined;
    }
}
